export const ETRIS03_TransactionMonitoring = {
  columns: 12,
  rows: 3,
  visual: {
    id: 1,
    type: "advancedTable",
    colorTheme: "colorTheme1",
    title: "Transaction Monitoring",
    binding: {
      data: {
        columns: [
          {
            name: "Transaction Type",
            columnName: "TransactionType",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Transaction Status",
            columnName: "TransactionStatus",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Order Setup",
            columnName: "OrderSetup",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Reference Number",
            columnName: "ReferenceNumber",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "PO Number",
            columnName: "PONumber",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Reference Date",
            columnName: "ReferenceDate",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Transaction Number",
            columnName: "TransactionNumber",
            width: "220px",
            align: "left",
            sortable: true
          },
          {
            name: "Transaction Date",
            columnName: "TransactionDate",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "DR Number",
            columnName: "DRNumber",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Customer Code",
            columnName: "CustomerCode",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Customer Name",
            columnName: "CustomerName",
            width: "250px",
            align: "left",
            sortable: true
          },
          {
            name: "Ship To Address",
            columnName: "ShiptoAddress",
            width: "350px",
            align: "left",
            sortable: true
          },
          {
            name: "Credit Term",
            columnName: "CreditTerm",
            width: "150px",
            align: "left",
            sortable: true
          },
          {
            name: "Amount",
            columnName: "Amount",
            width: "120px",
            align: "center",
            sortable: true
          },
          {
            name: "Principal",
            columnName: "Principal",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Sales Agent",
            columnName: "SalesAgent",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Forwarder",
            columnName: "Forwarder",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "Remarks",
            columnName: "Remarks",
            width: "250px",
            align: "left",
            sortable: true
          },
          {
            name: "Delivery Status",
            columnName: "DeliveryStatus",
            width: "180px",
            align: "left",
            sortable: true
          },
          {
            name: "With Collection",
            columnName: "WithCollection",
            width: "160px",
            align: "center",
            sortable: true
          },
          {
            name: "Return Docs",
            columnName: "ReturnDocs",
            width: "150px",
            align: "center",
            sortable: true
          }
        ],
        title: "CustomerCode",
        onLoad: "Pgn.IS03",
        subtotal: true,
        pagination: {
          show: true
        },
        endpoint: "ETRIS03",
        parameters: [
          {
            key: "PageIndex",
            value: "1"
          },
          {
            key: "ResultsPerPage",
            value: "10"
          }
        ]
      },
      context: {
        point: {
          onClick: {}
        }
      }
    }
  }
};